<template>
    <div class="modal fade" :id="id" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-md" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('tasks.validateTodo') }}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeModal">
                <span class="svg-icon svg-icon-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                          fill="currentColor" />
                    <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                          fill="currentColor" />
                  </svg>
                </span>
            </div>
          </div>

          <div class="modal-body">
            <div class="col-md-12">
              <div v-for="checklist in data.checklists" :key="checklist?.id" class="my-1 d-flex justify-content-between align-items-center p-2 rounded hover-effect">
                <CheckboxInput
                    v-model="checklist.checked"
                    :label="checklist?.title"
                    @update:modelValue="changeStatus(checklist?.id,$event)"
                    :is-required="false"
                    :bottom="false"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </template>

<script setup>
import { ref, defineProps, onMounted } from "vue";
import {useStore} from "vuex";
import Button from "@/components/Button.vue"
import CheckboxInput from "@/components/CheckboxInput.vue";
import {useRoute} from "vue-router";

const route = useRoute()

const store = useStore()
const props = defineProps({
    id: {
        type: String,
        required: true
    },
    data: {
        type: Object,
        default: {}
    },

})


const emits = defineEmits(['load', 'reloadData'])

function closeModal(){
    $('#'+props.id).modal('toggle')
}

const changeStatus = (id,checked) => {
  store.dispatch('checklists/changeChecklistStatus', {id: id, checked})
      .then(res => {
        store.dispatch('projects/projectLogs', {id: route.params.id})
        emits('reloadData')
      })
}


</script>

<style scoped></style>
